/**
 * Implements a chart picker like ms office
 */
import React, { useEffect, useRef } from 'react';
import { IChartPickerSelection } from '../../reducers/chart_picker';

const COLUMNS = 6;
const ROWS = 4;
const SQHEIGHT = 20;
const SQWIDTH = 36;
const WIDTH = 216;
const HEIGHT = 80;

const normalBorder = '#465060';
const normalBg = '#050506';
const activeBorder = '#314CF6';
const activeBg = 'rgba(67, 70, 76, 0.5)';
const hoverBorder = 'rgba(255, 255, 255, 0.1)';
const hoverBg = 'rgba(67, 70, 76, 0.3)';

const onDraw = (context: CanvasRenderingContext2D, x: number, y: number, selected: IChartPickerSelection) => {
  // Empty rect
  context.fillStyle = normalBg;
  context.fillRect(0, 0, WIDTH, HEIGHT);
  // Draw filled background
  context.fillStyle = activeBg;
  const activeWidth = selected.cols * SQWIDTH;
  const activeHeight = selected.rows * SQHEIGHT;
  context.fillRect(0, 0, activeWidth, activeHeight);
  // Draw grid
  context.strokeStyle = normalBorder;

  const colStep = WIDTH / COLUMNS;
  for (let index = 0; index <= COLUMNS; index++) {
    context.beginPath();
    const colX = colStep * index;
    context.moveTo(colX, 0);
    context.lineTo(colX, HEIGHT);
    context.closePath();
    context.stroke();
  }

  const rowStep = HEIGHT / ROWS;
  for (let index = 0; index <= ROWS; index++) {
    context.beginPath();
    const rowX = rowStep * index;
    context.moveTo(0, rowX);
    context.lineTo(WIDTH, rowX);
    context.closePath();
    context.stroke();
  }
  // Draw selection
  const selectedCols = Math.ceil(x / SQWIDTH);
  const selectedRows = Math.ceil(y / SQHEIGHT);
  context.strokeStyle = activeBorder;
  context.strokeRect(1, 1, selectedCols * SQWIDTH - 2, selectedRows * SQHEIGHT - 2);
  context.strokeStyle = hoverBorder;
  context.fillStyle = hoverBg;
  context.fillRect(1, 1, selectedCols * SQWIDTH - 2, selectedRows * SQHEIGHT - 2);

};

interface IGridPickerProps {
    selected: IChartPickerSelection
    onSelect: (input: IChartPickerSelection) => void;
}
/**
 *
 * @param param0
 * @returns
 */
const GridPicker = ({ selected, onSelect }: IGridPickerProps) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef) {
      const canvas: any = canvasRef.current;
      if (canvas) {
        canvas.width = WIDTH * 2;
        canvas.height = HEIGHT * 2;
        canvas.style.width = `${WIDTH}px`;
        canvas.style.height = `${HEIGHT}px`;

        const ctx = (canvas as any).getContext('2d');
        ctx.scale(2,2);

        onDraw(ctx, 0, 0, selected);
      }
    }
  }, [canvasRef, selected]);

  const onMouseMove = (e: React.SyntheticEvent<any>) => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ctx = (canvas as any).getContext('2d');
      onDraw(ctx, (e.nativeEvent as any).offsetX, (e.nativeEvent as any).offsetY, selected);
    }
  };

  const onClick = (e: React.SyntheticEvent<any>) => {
    const x = (e.nativeEvent as any).offsetX;
    const y = (e.nativeEvent as any).offsetY;
    const cols = Math.ceil(x / SQWIDTH);
    const rows = Math.ceil(y / SQHEIGHT);
    onSelect({ cols, rows });
  };

  return (
    <canvas
      className='picker__chart_picker'
      ref={canvasRef}
      onMouseMove={onMouseMove}
      onClick={onClick}
    />

  );
};

export default GridPicker;
